import { GitBranchIcon } from "lucide-react";
import { EnvironmentId, type ProviderKind } from "@cmmd-forge/contracts";

import { ProjectIcon, type ProjectCanonicalIdentity } from "~/components/ProjectIcon";
import { PROVIDER_SETTINGS_ICON_BY_PROVIDER } from "~/components/providerSettingsIcons";
import { ThreadOriginIcon } from "~/components/sidebar/ThreadOriginIcon";
import type { ThreadOrigin } from "~/components/sidebar/threadOrigin";
import { cn } from "~/lib/utils";

export function SidebarV2ProjectIcon(props: {
  readonly environmentId: string;
  readonly cwd: string | null;
  readonly name: string | null;
  readonly canonicalIdentity: ProjectCanonicalIdentity | undefined;
  readonly className?: string;
}) {
  return (
    <ProjectIcon
      environmentId={EnvironmentId.make(props.environmentId)}
      cwd={props.cwd ?? ""}
      projectName={props.name}
      canonicalIdentity={props.canonicalIdentity}
      className={props.className}
    />
  );
}

export function SidebarV2ProviderIcon(props: {
  readonly provider: string | null | undefined;
  readonly className?: string;
}) {
  const Icon = PROVIDER_SETTINGS_ICON_BY_PROVIDER[props.provider as ProviderKind];
  return Icon ? (
    <Icon aria-hidden className={cn("shrink-0 grayscale opacity-60", props.className)} />
  ) : null;
}

export function SidebarV2BranchMeta(props: {
  readonly branch: string | null;
  readonly className?: string;
}) {
  if (!props.branch) return <span className="flex-1" />;
  return (
    <span className={cn("flex min-w-0 flex-1 items-center gap-1 truncate", props.className)}>
      <GitBranchIcon aria-hidden className="size-3 shrink-0 text-muted-foreground/45" />
      <span className="truncate">{props.branch}</span>
    </span>
  );
}

export function SidebarV2OriginIcon(props: {
  readonly origin: ThreadOrigin;
  readonly className?: string;
}) {
  return <ThreadOriginIcon origin={props.origin} className={cn("size-3.5", props.className)} />;
}
